module.exports = __webpack_public_path__ + "static/media/handFlexed2.f0192f0e.png";